module.exports = __webpack_public_path__ + "img/segurify_icono_llamada_v5_190922.df8da66c.svg";